import {
  Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const personOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '140px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: '450px',
    emptyText: '暂无数据',
    column: [{
        label: '车主姓名',
        prop: 'name',
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        search: true,
        searchPlaceholder: '请输入姓名',
        span: 12,
      },
      {
        label: '手机号',
        prop: 'phone',
        hide: false,
        search: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        rules: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
      },
      {
        label: '车牌号',
        prop: 'plateCode',
        align: 'right',
        search: true,
        addDisplay: true,
        editDisplay: false,
        editDisabled: false,
        viewDisplay: true,
        overHidden: true,
        rules: [{
          required: true,
          message: '请输入车牌号',
          trigger: 'blur'
        }]
      },
      {
        label: '车主类型',
        prop: 'personnelType',
        align: 'right',
        type: "select",
        hide: false,
        search: true,
        searchSlot: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        editDisabled: false,
        overHidden: true,
        span: 12,
        rules: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }],
        dicData: [{
            label: '员工',
            value: 1,
          },
          {
            label: '访客',
            value: 2,
          },
        ],
        viewFormatter: (row, value) => {
          switch (Number(value)) {
            case 1:
              value = '员工'
              break;
            case 2:
              value = '访客'
              break;
            default:
              break;
          }
          return value
        },
        formatter: (row, value) => {
          switch (Number(value)) {
            case 1:
              value = '员工'
              break;
            case 2:
              value = '访客'
              break;
            default:
              break;
          }
          return value
        },
      },
      {
        label: '车牌类型',
        prop: 'plateType',
        type: 'select',
        hide: true,
        search: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车牌类型',
        rules: [{
          required: true,
          message: '请输入车牌类型',
          trigger: 'blur'
        }],
        viewFormatter: (row, value) => {
          switch (Number(value)) {
            case 0:
              value = '标准民用车'
              break;
            case 1:
              value = '02式民用车牌'
              break;
            case 2:
              value = '武警车车牌'
              break;
            case 3:
              value = '警车车牌'
              break;
            case 4:
              value = '民用车双行尾牌'
              break;
            case 5:
              value = '使馆车牌'
              break;
            case 6:
              value = '农用车车牌'
              break;
            case 7:
              value = '摩托车'
              break;
            case 8:
              value = '新能源车'
              break;
            case 13:
              value = '军车车牌'
              break;
            default:
              break;
          }
          return value
        },
        formatter: (row, value) => {
          switch (Number(value)) {
            case 0:
              value = '标准民用车'
              break;
            case 1:
              value = '02式民用车牌'
              break;
            case 2:
              value = '武警车车牌'
              break;
            case 3:
              value = '警车车牌'
              break;
            case 4:
              value = '民用车双行尾牌'
              break;
            case 5:
              value = '使馆车牌'
              break;
            case 6:
              value = '农用车车牌'
              break;
            case 7:
              value = '摩托车'
              break;
            case 8:
              value = '新能源车'
              break;
            case 13:
              value = '军车车牌'
              break;
            default:
              break;
          }
          return value
        },
        dicData: [{
            label: '标准民用车',
            value: '0'
          },
          {
            label: '02式民用车牌',
            value: '1'
          },
          {
            label: '武警车车牌',
            value: '2'
          },
          {
            label: '警车车牌',
            value: '3'
          },
          {
            label: '民用车双行尾牌',
            value: '4'
          },
          {
            label: '使馆车牌',
            value: '5'
          },
          {
            label: '农用车车牌',
            value: '6'
          },
          {
            label: '摩托车',
            value: '7'
          },
          {
            label: '新能源车',
            value: '8'
          },
          {
            label: '军车车牌',
            value: '13'
          }
        ],
      },
      {
        label: '车牌颜色',
        prop: 'plateColor',
        type: 'select',
        search: false,
        searchSlot: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车牌颜色',
        rules: [{
          required: true,
          message: '请输入车牌颜色',
          trigger: 'blur'
        }],
        viewFormatter: (row, value) => {
          switch (Number(value)) {
            case 0:
              value = '蓝色'
              break;
            case 1:
              value = '黄色'
              break;
            case 2:
              value = '白色'
              break;
            case 3:
              value = '黑色'
              break;
            case 4:
              value = '绿色'
              break;
            case 5:
              value = '民航黑色'
              break;
            case 255:
              value = '其他颜色'
              break;
            default:
              break;
          }
          return value
        },
        formatter: (row, value) => {
          switch (Number(value)) {
            case 0:
              value = '蓝色'
              break;
            case 1:
              value = '黄色'
              break;
            case 2:
              value = '白色'
              break;
            case 3:
              value = '黑色'
              break;
            case 4:
              value = '绿色'
              break;
            case 5:
              value = '民航黑色'
              break;
            case 255:
              value = '其他颜色'
              break;
            default:
              break;
          }
          return value
        },
        dicData: [{
            label: '蓝色',
            value: '0'
          },
          {
            label: '黄色',
            value: '1'
          },
          {
            label: '白色',
            value: '2'
          },
          {
            label: '黑色',
            value: '3'
          },
          {
            label: '绿色',
            value: '4'
          },
          {
            label: '民航黑色',
            value: '5'
          },
          {
            label: '其他颜色',
            value: '255'
          }
        ],
      },
      {
        label: '车辆类型',
        prop: 'vehicleType',
        type: 'select',
        search: false,
        hide: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        span: 12,
        align: 'right',
        placeholder: '请选择车辆类型',
        dicData: Dic.find('SENU038'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU038', Number(value))
          }
          return ''
        },
        rules: [{
          required: true,
          message: '请输入车辆类型',
          trigger: 'blur'
        }],
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU038', value) : ''
        },
      },
      {
        label: '车辆颜色',
        prop: 'vehicleColor',
        type: 'select',
        hide: false,
        addDisplay: true,
        editDisplay: false,
        viewDisplay: true,
        viewslot: true,
        span: 12,
        align: 'right',
        placeholder: '请输入车辆颜色',
        rules: [{
          required: true,
          message: '请输入车辆颜色',
          trigger: 'blur'
        }],
        dicData: Dic.find('SENU039'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU039', Number(value))
          }
          return ''
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU039', value) : ''
        },
      },
      {
        label: '访客车辆分组',
        prop: 'visitorVehicleTypeName',
        search: false,
        searchSlot: true,
        addDisplay: false,
        editDisplay: false,
        editDisabled: false,
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: '录入时间',
        prop: 'modifyTime',
        align: 'right',
        type: 'datetimerange',
        search: true,
        addDisplay: false,
        editDisplay: false,
        editDisabled: false,
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: '车主部门',
        prop: 'departmentName',
        search: true,
        searchSlot: true,
        span: 12,
      },
    ]
  }
}
export default personOption